import React from 'react';
import { useTranslation } from 'react-i18next';

import FavoriteUnselected from '@/assets/icons/favorite-unselected';
import { Text } from '@/components/TextComponent';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';

import { CasinoGame } from '../hooks/use-casino-games';
import { getLayoutComponent } from '../utils/utils';
import { LayoutHeader } from './Layout/LayoutHeader';

type FavoritesEmptyStateProps = {
    fallbackLayout?: { name: string; flags: string[]; items: CasinoGame[] };
};

export const FavoritesEmptyState = ({ fallbackLayout }: FavoritesEmptyStateProps) => {
    const { t } = useTranslation('casino');
    const FallbackLayout = getLayoutComponent(fallbackLayout?.flags[0]);

    return (
        <Box pb="s24">
            <LayoutHeader title={t('favorites')} />
            <Box gap="s16">
                <Box
                    height={220}
                    alignItems="center"
                    justifyContent="center"
                    gap="s12"
                    pl="s12"
                    pr="s16"
                    py="s12"
                    backgroundColor={ds.colorToken.background.neutral.subtler}
                    borderColor={ds.colorToken.border.subtle}
                    borderWidth={1}
                    borderRadius="r24"
                >
                    <FavoriteUnselected width={24} height={24} color={ds.colorValue.background.brand.emphasis} />
                    <Box gap="s2" width="100%">
                        <Text variant="titleMedium" textAlign="center">
                            {t('no_favorited_games_yet')}
                        </Text>
                        <Text
                            variant="bodySmall"
                            color={ds.colorToken.text.secondary}
                            opacity={0.7}
                            textAlign="center"
                            numberOfLines={1}
                        >
                            {t('no_favorited_games_yet_description')}
                        </Text>
                    </Box>
                </Box>
                {fallbackLayout?.items.length ? (
                    <FallbackLayout data={fallbackLayout.items} layoutHeaderProps={{ title: fallbackLayout.name }} />
                ) : null}
            </Box>
        </Box>
    );
};
